// extracted by mini-css-extract-plugin
export default {"root":"AddProductCard_root__5bekg","add-icon":"AddProductCard_add-icon__PB0vo"};